export const OPTIONS = Object.freeze({
  EMAIL: "email",
  TEXT: "cellPhone",
  PHONE: "phone"
})

export const KEYWORDS = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  FAILURE: "failure",
  DESC: "descending"
})

export const ROADSIDE_ASSISTANCE_URL =
  "https://app.urgent.ly/?campaign=CarAdvise&_ga=2.17219452.471890938.1691502289-655864227.1690987559#servicePicker"

export const TELEMATICS_URL = "https://envuetelematics.com/car-advise/"

export const AUTO_GLASS_REPAIR =
  "https://www.safelite.com/cjrepair-15?promo=15RPRCJ&utm_source=cjunction&utm_medium=affiliate&utm_campaign=15RPRCJ&gad_source=7&dclid=CjgKEAjwl_XBBhCr8_DHlJ_Hp3sSJABMfPkTT4kMyM4mwoGwuwgU-ZNBmJQ0NjGcML0Dv7lH8djIkPD_BwE"
export const AUTO_GLASS_REPLACEMENT =
  "https://www.safelite.com/cjreplace-30?promo=CJ30RPLC&utm_source=cjunction&utm_medium=affiliate&utm_campaign=cjreplace&gad_source=7&dclid=CjgKEAjwl_XBBhCr8_DHlJ_Hp3sSJABMfPkTUu7IfB4ykPtRV4tCu79t2LLXyiD2wse5yu7BjP-4FPD_BwE"
